import script from "./SupportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportPage.vue?vue&type=script&setup=true&lang=js"

import "./SupportPage.vue?vue&type=style&index=0&id=16b2eda8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b2eda8"]])

export default __exports__